/**
 * @exports
 * @class ContactForm
 */
import * as Choices from 'choices.js';

import { get, getAll } from '../../helpers/utilities';

export class ContactForm {
  private root: Element;
  private selectBoxes: HTMLSelectElement[];

  /**
   * Initialises a new instance of ContactForm
   *
   * @param root The root element for this block
   */
  constructor(root: Element) {
    this.root = root;
    this.selectBoxes = getAll('select', this.root) as HTMLSelectElement[];

    this.customDropdowns();
    this.otherJobTitle();
  }

  /**
   * Initiates out custom select dropdowns
   *
   * @private
   * @returns void
   */
  private customDropdowns(): void {
    if (this.selectBoxes) {
      const products = document.querySelector('.c-contact-form__products select');
      this.selectBoxes.forEach((select) => {
        if (select !== products) {
          // @ts-ignore
          new Choices(select, {
            itemSelectText: '',
            searchEnabled: false,
            shouldSort: false,
            removeItemsWithBackspace: false,
            removeItemButton: true,
          });
        }
      });

      if (products) {
        // @ts-ignore
        new Choices(products, {
          itemSelectText: '',
          placeholder: true,
          placeholderValue: 'Select a product',
          searchEnabled: false,
          shouldSort: false,
          removeItemsWithBackspace: false,
          removeItemButton: true,
        });
      }
    }
  }

  /**
   * Toggles the other field when job title is set to other
   *
   * @private
   * @returns void
   */
  private otherJobTitle(): void {
    const jobTitleField = get('.js-contact-form__job-title select', this.root) as HTMLSelectElement;
    const otherField = get('.js-contact-form__other-job', this.root);
    const otherFieldInput = get('input', otherField) as HTMLInputElement;
    if (jobTitleField && otherField && otherFieldInput) {
      jobTitleField.addEventListener('change', () => {
        if (jobTitleField.value.toLowerCase() === 'other') {
          otherField.classList.remove('u-hidden');
        } else {
          otherField.classList.add('u-hidden');
          otherFieldInput.value = '';
        }
      });
    }
  }
}
